// extracted by mini-css-extract-plugin
var _1 = "card__N5JZu";
var _2 = "cardBlock__k5RqF";
var _3 = "container__QuCzu";
var _4 = "header__xhr6d";
var _5 = "image__iTiGd";
var _6 = "imageBlock__zzZtP";
var _7 = "main__N0LUq";
export { _1 as "card", _2 as "cardBlock", _3 as "container", _4 as "header", _5 as "image", _6 as "imageBlock", _7 as "main" }
export default { "card": _1, "cardBlock": _2, "container": _3, "header": _4, "image": _5, "imageBlock": _6, "main": _7 }
